type KebabCase<T extends string> = T extends `${infer First}${infer Rest}`
	? First extends Uppercase<First>
		? `-${Lowercase<First>}${KebabCase<Rest>}`
		: `${First}${KebabCase<Rest>}`
	: T

export type KebabCaseProps<T> = {
	[K in keyof T as K extends string ? KebabCase<K> : K]: T[K]
}

export const kebabCase = (str: string) =>
	str
		.split(/(?=[A-Z])/g)
		.map((s) => s.trim())
		.join('-')
		.toLowerCase()

export const pascalCase = (str: string) =>
	str.replace(/(?:^|-)([a-z0-9])/g, (_, char) => char.toUpperCase())
